var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-stepper-content",
    { attrs: { step: "1" } },
    [
      _c(
        "v-form",
        {
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("v-text-field", {
            attrs: {
              "data-cy": "s3AccessToken",
              value: _vm.accessToken,
              label: "User Account Access Token",
              "lazy-validation": "lazy",
              rules: [_vm.reqRule],
            },
            on: { input: _vm.change_access_token },
          }),
          _c("v-text-field", {
            attrs: {
              "data-cy": "s3SecretToken",
              value: _vm.secretToken,
              label: "User Account Secret Token",
              type: "password",
              rules: [_vm.reqRule],
            },
            on: { input: _vm.change_secret_token },
          }),
          _c("v-text-field", {
            attrs: {
              value: _vm.region,
              label: "Bucket Region (Default: us-east-1)",
              type: "text",
            },
            on: { input: _vm.change_region },
          }),
          _c("v-text-field", {
            attrs: {
              "data-cy": "s3Endpoint",
              value: _vm.endpoint,
              label: "S3 Endpoint (Default: AWS)",
              hint: "Leave blank for AWS, or enter a custom S3-compatible URL (e.g. https://minio.example.com)",
              "persistent-hint": "persistent-hint",
              type: "text",
            },
            on: { input: _vm.change_endpoint },
          }),
          _c("v-checkbox", {
            staticClass: "mb-4",
            attrs: {
              "data-cy": "s3SkipSts",
              "input-value": _vm.skipSts,
              label: "Use credentials directly (skip STS)",
              hint: "Enable for S3-compatible servers that don't support AWS STS. Disables MFA login.",
              "persistent-hint": "persistent-hint",
            },
            on: { change: _vm.change_skip_sts },
          }),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mx-1 mb-2" },
        [
          _c(
            "v-btn",
            {
              staticClass: "my-2 mr-3",
              attrs: {
                "data-cy": "s3BasicLogin",
                color: "primary",
                disabled: !_vm.valid,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("auth-basic")
                },
              },
            },
            [_vm._v(" Basic Login ")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "my-2",
              attrs: { color: "green", disabled: !_vm.valid || _vm.skipSts },
              on: {
                click: function ($event) {
                  return _vm.$emit("goto-mfa")
                },
              },
            },
            [_vm._v(" MFA Login ")]
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "my-2",
              on: {
                click: function ($event) {
                  return _vm.$emit("show-help")
                },
              },
            },
            [
              _vm._v(" Help "),
              _c("v-icon", { staticClass: "ml-2" }, [
                _vm._v(" mdi-help-circle "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }